import { TextInput } from 'flowbite-react';
import React, { useEffect, useMemo, useState } from 'react';
import Downshift from 'downshift';
import cx from 'classnames';
import { TbSearch } from 'react-icons/tb';

const defaultTextInputStyle = {
	color: 'black',
	backgroundColor: 'white',
	border: '1px solid #D1D5DB',
};

interface Props {
	onChange: (value: string) => void;
	textInputStyle?: {
		[key: string]: string;
	};
	onType: (value: string) => void;
	options: { name: string; value: string }[];
	value?: string;
	placeholder: string;
	dynamicClassName?: string;
	creatable?: boolean;
}

function DynamicFieldSelection({
	onChange,
	options,
	textInputStyle,
	value,
	onType,
	placeholder,
	dynamicClassName,
	creatable = false,
}: Props) {
	const [typedDynamicInput, setTypedDynamicInput] = useState('');

	useEffect(() => {
		setTypedDynamicInput(value || '');
	}, [value]);

	useEffect(() => {
		if (typedDynamicInput) onType(typedDynamicInput);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [typedDynamicInput]);

	return (
		<div className={dynamicClassName}>
			<Downshift
				inputValue={typedDynamicInput}
				onInputValueChange={inputValue => setTypedDynamicInput(inputValue)}
				itemToString={item => (item ? item.name : '')}
				// onChange={selection => onChange(selection.value)}
				onChange={selection => {
					if (creatable || options.some(opt => opt.value === selection.value)) {
						onChange(selection.value);
					} else {
						setTypedDynamicInput(value || '');
					}
				}}
			>
				{({
					selectItem,
					getInputProps,
					getRootProps,
					getMenuProps,
					highlightedIndex,
					isOpen,
					selectedItem,
					getItemProps,
				}) => {
					const { onChange, onBlur, ...inputProps } = getInputProps({
						className: 'flex-grow',
						id: 'company',
					});
					return (
						<div className="relative">
							<div className="flex shadow-sm gap-0.5" {...getRootProps({}, { suppressRefError: true })}>
								<TextInput
									placeholder={placeholder}
									icon={() => <TbSearch color="#C7C9D9" />}
									// onBlur={e => {
									// 	selectItem({ name: typedDynamicInput, value: typedDynamicInput });
									// 	onBlur && onBlur(e);
									// }}
									onBlur={e => {
										// Only allow selection if creatable is true or if the value exists in options
										if (creatable || options.some(opt => opt.value === typedDynamicInput)) {
											selectItem({ name: typedDynamicInput, value: typedDynamicInput });
										} else {
											// If not creatable and value doesn't exist in options, revert to previous value
											setTypedDynamicInput(value || '');
										}
										onBlur && onBlur(e);
									}}
									onChange={e => {
										onChange && onChange(e);
									}}
									{...inputProps}
									style={textInputStyle ?? defaultTextInputStyle}
								/>
								{/* <button
                                    aria-label={'toggle menu'}
                                    className="px-2"
                                    type="button"
                                    {...getToggleButtonProps()}
                                >
                                    {isOpen ? <>&#8593;</> : <>&#8595;</>}
                                </button> */}
							</div>
							<ul
								className={`absolute rounded-[0.5rem] border dark:bg-black w-full bg-[#fff] mt-1 shadow-md max-h-80 overflow-scroll p-0 z-10 ${!(isOpen && options.length) && 'hidden'
									}`}
								{...getMenuProps()}
							>
								{options.map((item, index) => (
									<li
										className={cx(
											highlightedIndex === index && 'bg-blue-300',
											selectedItem === item && 'font-bold',
											'py-2 px-3 shadow-sm flex flex-col',
										)}
										{...getItemProps({
											key: item.value,
											index,
											item,
										})}
									>
										<span>{item.name}</span>
									</li>
								))}
							</ul>
						</div>
					);
				}}
			</Downshift>
		</div>
	);
}

export default DynamicFieldSelection;
